
import './Appneed.css'

const Appneed = () =>{
    return (
        <>
        
        <div className="needsbg">
            <div className='container needcontent' >
                <h4 className='needhead' >Why You Need an App?</h4>
                <p className='needpara'>In today's digital age, mobile apps are an essential part of most people's daily lives. From social networking and entertainment to productivity and business, mobile apps play a vital role in how we interact with technology.</p>
            </div>
        </div>
        </>
        );
}

export default Appneed